// File: src/components/layouts/Core/SplitLayout/SplitLayout.tsx
// Purpose: Layout or container component

import React from "react";
import styled from "styled-components";
import { AppTheme } from "theme";

export interface SplitLayoutProps {
  children: [React.ReactNode, React.ReactNode]; // Two children
  leftWidth?: string; // Left column width
  rightWidth?: string; // Right column width
  gap?:  keyof AppTheme["spacing"]; // Uses theme spacing
  responsive?: boolean; // Enables responsive stacking
}

const StyledSplitLayout = styled.div<SplitLayoutProps>`
  display: grid;
  grid-template-columns: ${({ leftWidth, rightWidth }) => `${leftWidth || "1fr"} ${rightWidth || "1fr"}`};
  gap: ${({ theme, gap }) => (gap ? theme.spacing[gap] : theme.spacing.md)};

  ${({ responsive, theme }) =>
    responsive &&
    `
    @media (max-width: ${theme.breakpoints.mobile}) {
      grid-template-columns: 1fr;
      gap: ${theme.spacing.sm};
    }
  `}
`;

export const SplitLayout: React.FC<SplitLayoutProps> = ({
  children,
  leftWidth = "1fr",
  rightWidth = "1fr",
  responsive = true,
  ...props
}) => {
  return (
    <StyledSplitLayout leftWidth={leftWidth} rightWidth={rightWidth} responsive={responsive} {...props}>
      {children}
    </StyledSplitLayout>
  );
};